import { SuiteManifest } from '../manifest';
import { operationsRoutes } from './routes';

export const operationsManifest: SuiteManifest = {
  id: 'operations',
  code: 'S8_OPS',
  name: 'Administration & Ops',
  basePath: '/operations',
  icon: 'shield',
  description:
    'Multi-branch isolation, multi-level approval workflows, event-driven automation rules, campus assets, and visitor logs.',
  requiredPermission: 'ops.read',
  allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'accountant'],
  nav: [
    {
      label: 'Campus Branches',
      path: '/operations/branches',
      icon: 'building',
      group: 'Organization',
      status: 'live',
    },
    {
      label: 'Approval Workflows',
      path: '/operations/approvals',
      icon: 'check-circle-2',
      group: 'Governance',
      status: 'live',
    },
    {
      label: 'Event Automations',
      path: '/operations/automations',
      icon: 'zap',
      group: 'Governance',
      status: 'live',
    },
    {
      label: 'Asset Inventory',
      path: '/operations/assets',
      icon: 'package',
      group: 'Facilities',
      status: 'live',
    },
    {
      label: 'Visitor Log',
      path: '/operations/visitors',
      icon: 'user-check',
      group: 'Facilities',
      status: 'live',
    },
  ],
  routes: operationsRoutes,
};

export { operationsRoutes } from './routes';
export default operationsManifest;
